import { combineReducers } from "@reduxjs/toolkit";

import resiliation from "modules/resiliation/store/resiliation.slice";
import config from "modules/config/store/config.slice";
import notification from "modules/notification/store/notification.slice";

export const rootReducer  = combineReducers({
  resiliation,
  config,
  notification
})

export type RootState = ReturnType<typeof rootReducer >
